import AccordionInteraction from './accordions'
import NavigationHandler from './navigation'
import ShowHideInteraction from './showHide'

export default function contentInteractions(
  node: HTMLElement,
  setIsRebuttals: React.Dispatch<React.SetStateAction<boolean>>,
  setIsScripts: React.Dispatch<React.SetStateAction<boolean>>,
  setCurrentScript: React.Dispatch<React.SetStateAction<number>>,
  setCurrentRebuttal: React.Dispatch<React.SetStateAction<number>>,
): void {
  AccordionInteraction(node)
  ShowHideInteraction(node)
  NavigationHandler({
    node,
    setIsRebuttals,
    setIsScripts,
    setCurrentScript,
    setCurrentRebuttal,
  })
}
